import { useLocation, Link } from "react-router-dom";
import { useTalent } from "../../../providers/TalentProvider";
import ProfileContainer from "../components/ProfileContainer";
import Team from "../../../models/Team";


const TalentProfileAbout = () => {
    const { talent } = useTalent();
    const location = useLocation();

    return (
        <ProfileContainer>
            <div id="about">

                <h4 className="text-bold font-xl pb-6">About</h4>

                <div className="flex gap-6">
                    <div className="flex-1">
                        <p dangerouslySetInnerHTML={{ __html: talent.bio }} className="whitespace-pre-wrap" />
                    </div>

                    <div className="flex flex-col gap-6 wfull">
                        <div className="bg-wrippleOffWhite p-2.5 rounded-lg flex flex-col gap-2">
                            <p>Primary Language: <strong>{talent.primary_language}</strong></p>
                            <p>Hours available per week: <strong>{talent.available_hours_per_week}</strong></p>
                            <p>Available to work on site: <strong>{talent.can_travel_for_work ? 'Yes' : 'No'}</strong></p>
                        </div>

                        {talent.positions?.length && (
                            <div>
                                <p className="text-bold pb-1.5">Teams & Collectives</p>

                                {talent.positions.map(position => {
                                    return (
                                        <Link
                                            key={position.team.id}
                                            to={{ ...Team.make({ ...position.team }).profilePage({}), key: TB.uuid() }}
                                            state={{
                                                linkParams: {
                                                    title: talent.firstNamePlusInitial(),
                                                    path: location.pathname,
                                                }
                                            }}
                                            className="text-blue-400 underline"
                                        >
                                            {position.team.name}
                                        </Link>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ProfileContainer>
    )
}

export default TalentProfileAbout;

// playing with skeleton for section instead of <LoadingBanner />
const AboutSkeleton = () => {
    return (
        <ProfileContainer>
            <div className="flex gap-6">
                <div className="flex-1 flex flex-col gap-2">
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                    <div className="skeleton h-3 w-full" />
                </div>

                <div className="flex flex-col gap-6 wfull">
                    <div className="skeleton w-[230px] h-[100px]" />

                    <div className="flex flex-col gap-2">
                        <div className="skeleton h-3 w-full" />
                        <div className="skeleton h-3 w-full" />
                        <div className="skeleton h-3 w-full" />

                    </div>
                </div>

            </div>
        </ProfileContainer>
    )
}